module.exports = __webpack_public_path__ + "img/Img13_204468_HaGd-11-111.7b407c7f.jpg";